import React from "react";
import { Result, Typography, Divider } from "antd";
import {
  CheckCircleOutlined,
  TrophyOutlined,
  StopOutlined,
} from "@ant-design/icons";

interface AssessmentBlockedProps {
  status: "shortlisted" | "hired" | "rejected" | string;
}

const statusConfig: Record<
  string,
  {
    icon: React.ReactNode;
    title: string;
    subTitle: string;
    resultStatus: "success" | "error" | "warning" | "info";
  }
> = {
  shortlisted: {
    icon: <CheckCircleOutlined style={{ fontSize: 72, color: "#52c41a" }} />,
    title: "You've Been Shortlisted!",
    subTitle:
      "Congratulations! You have been shortlisted for the next stage of the hiring process. The hiring team will reach out to you shortly with further details.",
    resultStatus: "success",
  },
  hired: {
    icon: <TrophyOutlined style={{ fontSize: 72, color: "#faad14" }} />,
    title: "Congratulations, You're Hired!",
    subTitle:
      "You have successfully been selected for this position. Please check your email for the official offer and onboarding details.",
    resultStatus: "success",
  },
  rejected: {
    icon: <CheckCircleOutlined style={{ fontSize: 72, color: "#52c41a" }} />,
    title: "Application Under Review",
    subTitle:
      "Thank you for your time and effort. Our Team will contact you soon. We appreciate your interest and encourage you to apply for future openings.",
    resultStatus: "success",
  },
};

const AssessmentBlocked: React.FC<AssessmentBlockedProps> = ({ status }) => {
  const config = statusConfig[status] ?? {
    icon: null,
    title: "Assessment Unavailable",
    subTitle:
      "The assessment is not available at this time. Please contact the hiring team for more information.",
    resultStatus: "warning" as const,
  };

  return (
    <div className="ai-assessment-result-container">
      <div className="ai-assessment-section-title">
        <Typography.Title level={5} style={{ margin: "0px", fontSize: "14px" }}>
          Assessment Status
        </Typography.Title>
      </div>
      <Divider style={{ margin: "0px" }} />
      <div style={{ width: "100%", maxWidth: "800px", margin: "0 auto" }}>
        <Result
          status={config.resultStatus}
          icon={config.icon}
          title={config.title}
          subTitle={config.subTitle}
        />
      </div>
    </div>
  );
};

export default AssessmentBlocked;
